var rtl_rtlignore_default = {
  "rtl": "Gc0yH",
  "ltr": "cY4av"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
